import {
    Component,
    Inject,
    Input,
} from "@angular/core";
import {OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {MAT_DIALOG_DATA} from "@angular/material";

@Component({
    selector: 'error-modal',
    template: `<div class="modal-wrap">
    <h2 mat-dialog-title>Ooops! Some Error, do not worry!</h2>
    <mat-dialog-content>
        <h3>Something went wrong.</h3>
    </mat-dialog-content>
    <mat-dialog-actions>
    <button mat-raised-button *ngIf="modalProperties?.closing" (click)="onCloseModalDialog()" class="mat-primary">Close</button>
    </mat-dialog-actions>
</div>

`,
    styles: [`.modal-close-button{cursor:pointer;position:absolute;top:-22px;right:-22px}.modal-wrap{position:relative}`]
})
export class ModalComponent implements OnInit {

    public modalProperties = {
        closing: null
    };

    // ########################################

    constructor(
        public dialogRef: MatDialogRef<ModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    public onCloseModalDialog(): void {
        this.dialogRef.close();
    }

    // ########################################

    public ngOnInit(): void {
        this.modalProperties = {
            closing: this.data.properties.closing
        };
    }

    // ########################################
}
